/** Phân quyền — bán online (đơn hàng sàn TMĐT + hàng liên kết + đối soát + gian hàng) */
export const BAN_ONLINE_PERMISSION_CODES = {
  WEB_BH_DON_HANG_ONLINE_LIST: 'WEB_BH_DON_HANG_ONLINE_LIST',
  WEB_BH_DON_HANG_ONLINE_DONG_BO: 'WEB_BH_DON_HANG_ONLINE_DONG_BO',
  WEB_BH_DON_HANG_ONLINE_TAO_HOA_DON: 'WEB_BH_DON_HANG_ONLINE_TAO_HOA_DON',
  WEB_BH_HANG_HOA_LIEN_KET_LIST: 'WEB_BH_HANG_HOA_LIEN_KET_LIST',
  WEB_BH_HANG_HOA_LIEN_KET_DONG_BO: 'WEB_BH_HANG_HOA_LIEN_KET_DONG_BO',
  WEB_BH_HANG_HOA_LIEN_KET_LIEN_KET: 'WEB_BH_HANG_HOA_LIEN_KET_LIEN_KET',
  WEB_BH_DOI_SOAT_ONLINE_LIST: 'WEB_BH_DOI_SOAT_ONLINE_LIST',
  WEB_BH_DOI_SOAT_ONLINE_DANH_DAU: 'WEB_BH_DOI_SOAT_ONLINE_DANH_DAU',
  WEB_BH_GIAN_HANG_ONLINE_LIST: 'WEB_BH_GIAN_HANG_ONLINE_LIST',
  WEB_BH_GIAN_HANG_ONLINE_KET_NOI: 'WEB_BH_GIAN_HANG_ONLINE_KET_NOI',
  WEB_BH_GIAN_HANG_ONLINE_NGAT_KET_NOI: 'WEB_BH_GIAN_HANG_ONLINE_NGAT_KET_NOI',
  WEB_BH_GIAN_HANG_ONLINE_XOA: 'WEB_BH_GIAN_HANG_ONLINE_XOA',
  /** Thêm/sửa mảng–CN nguồn bán gộp trên gian hàng. */
  WEB_BH_GIAN_HANG_ONLINE_CAU_HINH_BAN_GOP:
    'WEB_BH_GIAN_HANG_ONLINE_CAU_HINH_BAN_GOP',
  WEB_BH_THIET_LAP_KENH_LIST: 'WEB_BH_THIET_LAP_KENH_LIST',
  WEB_BH_THIET_LAP_KENH_LUU: 'WEB_BH_THIET_LAP_KENH_LUU',
} as const

export type BanOnlinePermissionCode =
  (typeof BAN_ONLINE_PERMISSION_CODES)[keyof typeof BAN_ONLINE_PERMISSION_CODES]
